import { FaqItem } from '@anm/components/Faq';
import FaqSection from '@anm/components/sections/FaqSection';
import faq, { FaqItemId } from '@anm/data/faq/wave/wavePricingFaqData';
import useScrollIntoViewRef from '@anm/hooks/useScrollIntoViewRef';
import { FC } from 'react';

export type AskedQuestionsSectionProps = {
  openIds?: FaqItemId[];
};

const collapseItems = (
  openIds: FaqItemId[],
  scrollRef: React.RefObject<HTMLElement>
): FaqItem[] =>
  faq.map(item => {
    const isOpened = openIds.includes(item.id);
    return { ...item, isOpened, scrollRef: isOpened ? scrollRef : null };
  });

const AskedQuestionsSection: FC<AskedQuestionsSectionProps> = ({ openIds }) => {
  const scrollRef = useScrollIntoViewRef();
  const list = openIds ? collapseItems(openIds, scrollRef) : faq;

  return <FaqSection list={list} title="Frequently Asked Questions" />;
};

export default AskedQuestionsSection;
